import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL || (process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : 'http://localhost:5000/api');

const chatService = {
    /**
     * Obtener lista de conversaciones (salas)
     */
    getConversations: async (token) => {
        const res = await axios.get(`${API_URL}/chat/conversations`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    /**
     * Obtener mensajes de una sala por ID
     */
    getMessagesByRoom: async (roomId, token) => {
        const res = await axios.get(`${API_URL}/chat/messages/room/${roomId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    /**
     * Obtener mensajes de una conversación con un usuario (busca/crea sala DIRECT)
     */
    getMessagesByUser: async (userId, token) => {
        const res = await axios.get(`${API_URL}/chat/messages/user/${userId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    /**
     * Enviar un mensaje
     * Puede enviar por roomId o por recipientId (para iniciar nueva conversacion DIRECT)
     * Soporta envío de archivos mediante FormData.
     */
    sendMessage: async ({ recipientId, content, roomId, file }, token) => {
        let payload;
        let headers = { 'Authorization': `Bearer ${token}` };

        if (file) {
            payload = new FormData();
            if (roomId) payload.append('roomId', roomId);
            if (recipientId) payload.append('recipientId', recipientId);
            if (content) payload.append('content', content);
            payload.append('file', file);
            // Axios setea el Content-Type para FormData automáticamente
        } else {
            payload = { recipientId, content, roomId };
        }

        const res = await axios.post(`${API_URL}/chat/send`, payload, {
            headers
        });
        return res.data;
    },

    /**
     * Agregar miembros a una sala existente
     */
    addMembers: async (roomId, userIds, token) => {
        const res = await axios.post(`${API_URL}/chat/add-members`, { roomId, userIds }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    /**
     * Obtener conteo de mensajes no leídos
     */
    getUnreadCount: async (token) => {
        const res = await axios.get(`${API_URL}/chat/unread`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    deleteMessage: async (messageId, token) => {
        const res = await axios.delete(`${API_URL}/chat/messages/${messageId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    },

    /**
     * Salir de un grupo de chat
     */
    leaveGroup: async (roomId, token) => {
        const res = await axios.post(`${API_URL}/chat/leave/${roomId}`, {}, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.data;
    }
};

export default chatService;
